<template>
	<div>
		<div class="info__mapblock" id="mapblock"></div>
	</div>
</template>

<script>
  import 'leaflet'
  //import 'leaflet.markercluster'

  export default {
    name: "maps",

    data() {
      return {
        myMap: '',
        bounds: [],
        map_coord: [55.78089657, 49.12730000]
      }
    },
    props: {
      addr: ''
    },
    methods: {
      map() {
        let map = L.map('mapblock').setView(this.map_coord, 15);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          //attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);

        L.marker(this.map_coord).addTo(map)
        .bindPopup('Магазин "Вся Польза"')
        .openPopup();

        this.myMap = map;

      },
    },
    mounted() {
      this.map();
    }
  }
</script>


// WEBPACK FOOTER //
// themes/polza/src/js/components/maps.vue